import React from 'react'
import AttrArrayInput from '../../input/attrarray'
import DateInput from '../../input/date'
import SelectInput from '../../input/select'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import UploadInput from '../../input/upload'

export default class UpcEditForm extends React.Component {
  onUpload (filename, files) {
    this.props.store.uploadAws(filename, files)
  }

  onUploadDelete (filename) {
    // TODO
  }

  changeAttrArrayValue (platform, name, value) {
    this.props.store.changeAttrArrayValue(platform, name, value)
  }

  render () {
    const { store, updateField, arrayMap } = this.props
    const entity = store.cv.record
    const errors = store.cv.errors

    return (
      <div>
        <div className='row'>
          <div className='col-xs-12 col-sm-12 col-md-6'>
            <AttrArrayInput label={store.__('description')}
              platform='upc' name='desc' attrs={arrayMap} InputComponent={TextInput}
              updateField={this.changeAttrArrayValue.bind(this)} errors={errors} />
            <AttrArrayInput label={store.__('short description')}
              platform='upc' name='shortdesc' attrs={arrayMap} InputComponent={TextInput}
              updateField={this.changeAttrArrayValue.bind(this)} errors={errors} />
            <AttrArrayInput label={store.__('billing ID')}
              platform='upc' name='billingid' attrs={arrayMap} InputComponent={TextInput}
              updateField={this.changeAttrArrayValue.bind(this)} errors={errors} />
            <AttrArrayInput label={store.__('provider')}
              platform='upc' name='Provider' attrs={arrayMap} InputComponent={TextInput}
              updateField={this.changeAttrArrayValue.bind(this)} errors={errors} />
            <AttrArrayInput label={store.__('provider ID')}
              platform='upc' name='Provider_ID' attrs={arrayMap} InputComponent={TextInput}
              updateField={this.changeAttrArrayValue.bind(this)} errors={errors} />
          </div>
          <div className='col-xs-12 col-sm-12 col-md-6'>
            <AttrArrayInput label={store.__('display run time ID')}
              platform='upc' name='Display_Run_Time' attrs={arrayMap} InputComponent={TextInput}
              updateField={this.changeAttrArrayValue.bind(this)} errors={errors} />
            <AttrArrayInput label={store.__('licensing window start')}
              platform='upc' name='Licensing_Window_Start' attrs={arrayMap} InputComponent={DateInput}
              updateField={this.changeAttrArrayValue.bind(this)} errors={errors} />
            <AttrArrayInput label={store.__('licensing window end')}
              platform='upc' name='Licensing_Window_End' attrs={arrayMap} InputComponent={DateInput}
              updateField={this.changeAttrArrayValue.bind(this)} errors={errors} />
            <AttrArrayInput label={store.__('aspect ratio')}
              platform='upc' name='Aspect_Ratio' attrs={arrayMap} InputComponent={SelectInput}
              updateField={this.changeAttrArrayValue.bind(this)} errors={errors}
              optionsrecord={store.options} optionsattr={'AspectRatios'} />
          </div>
        </div>
        <div className='row'>
          <div className='col-xs-12 col-sm-12'>
            {entity.has('id') && false ? (
              <UploadInput store={store}
                platform='upc' folder='artwork' filename='poster' postfix='jpg'
                label={store.__('poster')} maxSize={100}
                allowedContentTypes={['image/jpeg']}
                onDelete={this.onUploadDelete.bind(this)}
                onUpload={this.onUpload.bind(this)} />
            ) : null}
          </div>
        </div>
      </div>
    )
  }
}
